import ApolloClient from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import Vue from 'vue';
import VueApollo from 'vue-apollo';
import VueTheMask from 'vue-the-mask';

import App from './App.vue';
import router from './router';
import store from './store';
import clickOutside from '@/utils/click-outside';

Vue.use(VueTheMask);
Vue.use(VueApollo);
Vue.directive('clickOutside', clickOutside);
Vue.config.productionTip = false;

let token = localStorage.getItem('token');
Object.defineProperty(Vue.prototype, '$token', {
  get() {
    return token;
  },
  set(value) {
    token = value;
  }
});

interface Headers {
  Authorization?: string;
  'Content-Type': string;
}

const uri: string =
  process.env.NODE_ENV === 'development'
    ? process.env.VUE_APP_SERVER_API_DEVELOPMENT || ''
    : process.env.VUE_APP_SERVER_API_PRODUCTION || '';

const getHeaders = (): Headers => {
  const headers: Headers = { 'Content-Type': 'application/json' };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

const fetchWrap = (endpoint: string, options: any) =>
  window.fetch(endpoint, {
    ...options,
    headers: getHeaders()
  });

const link = new HttpLink({
  fetch: (endpoint: string, options: any) => fetchWrap(endpoint, options),
  headers: getHeaders(),
  uri
});

export const client = new ApolloClient({
  link,
  cache: new InMemoryCache({
    addTypename: true
  })
});

const apolloProvider = new VueApollo({ defaultClient: client });

new Vue({
  router,
  store,
  render: (h: any) => h(App),
  apolloProvider
}).$mount('#app');
